import React, { useState, useEffect } from 'react';
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath';
import PagesAuthHeader from './common/header';
import { Link, useNavigate } from 'react-router-dom';
import { all_routes } from '../../../../core/data/routes/all_routes';
import AuthFooter from './common/footer';
import { auth, signInWithGoogle, facebookProvider, db, messaging } from '../../../../firebase';
import { signInWithEmailAndPassword, RecaptchaVerifier, signInWithPopup, OAuthProvider, signInWithPhoneNumber } from 'firebase/auth';
import { notification } from 'antd';
import { DiApple } from "react-icons/di";
import PhoneInput from 'react-phone-input-2';
import { InputOtp } from 'primereact/inputotp';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { getToken } from "firebase/messaging";


const Login2 = () => {
  const routes = all_routes;
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   setError("");

  //   try {
  //     const response = await signInWithEmailAndPassword(auth, email, password);
  //     const token = await response.user.getIdToken();

  //     // For security, use cookies instead of localStorage for tokens
  //     localStorage.setItem("token", token); // Ideally, store in secure cookies
  //     setLoginSuccess(true);
  //     openNotificationWithIcon("success", "Login Success", "You have successfully logged in!");
  //     setTimeout(() => {
  //       navigate("/OverviewPage");
  //     }, 2000);
  //   } catch (err) {
  //     setError(err.message);
  //     openNotificationWithIcon("error", "Login Failed", err.message);
  //     setLoginSuccess(false);
  //   }
  // };

  const [api, contextHolder] = notification.useNotification();

const openNotification = (type, message, description) => {
  api[type]({
    message,
    description,
    placement: "topRight",  // You can change this to topLeft, bottomRight, etc.
  });
};


  // const openNotificationWithIcon = (type, title, description) => {
  //   api[type]({
  //     message: title,
  //     description,
  //   });
  // };

  // FaceBook Login Start ---------

  const handleFacebookLogin = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      console.log("Facebook Sign-In Successful:", result.user);
      navigate(routes.customerDashboard);
      openNotification("success", "Facebook Login Successful", "You have successfully logged in with Facebook.");
    } catch (error) {
      console.error("Facebook login failed", error.message);
      openNotification("error", "Login Failed", "Facebook login failed. Please try again.");
    }
  };

  // GoogleLogin start-------------
  const formatDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ` +
           `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}.` +
           `${String(now.getMilliseconds()).padStart(6, "0")}`; // Pad microseconds to 6 digits
  };
  const requestNotificationToken = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: "181920507326-25idgluq5h1nnnd74274vb27nsopet5e.apps.googleusercontent.com", // Get this from Firebase console
        });
  
        console.log("FCM Token:", token);
        return token; // Return notification token
      } else {
        console.warn("Notification permission denied!");
        return "";
      }
    } catch (error) {
      console.error("Error getting notification token:", error);
      return "";
    }
  };
  


  const [user, setUser] = useState(null);

//   import { notification } from "antd";

// const [api, contextHolder] = notification.useNotification();

// const openNotification = (type, message, description) => {
//   api[type]({
//     message,
//     description,
//     placement: "topRight",
//   });
// };

const handleGoogleLogin = async () => {
  try {
    const user = await signInWithGoogle();
    console.log("Logged in user:", user);

    if (user) {
      setUser(user);
      openNotification("info", "Logging in...", "Fetching user details.");

      // Create a document reference in Firestore
      const userRef = doc(db, "users", user.uid);

      // Retrieve existing user data if available
      const userSnapshot = await getDoc(userRef);
      const existingData = userSnapshot.exists() ? userSnapshot.data() : {};
      const notificationToken = await requestNotificationToken();

      // Prepare the user details object dynamically
      const userDetails = {
        account_create: existingData.account_create || formatDate(),
        achievements: existingData.achievements || [{ description: "0.5% offer each services", title: "New Contributor" }],
        address: {
          city: existingData.address?.city || "",
          country: existingData.address?.country || "",
          state: existingData.address?.state || "",
          street: existingData.address?.street || "",
          zip_code: existingData.address?.zip_code || "",
        },
        bio: existingData.bio || "",
        contact_info: {
          alternate_phone: existingData.contact_info?.alternate_phone || "",
          notification_token: notificationToken, // Store FCM Token
          secondary_email: existingData.contact_info?.secondary_email || "",
        },
        displayname: user.displayName || existingData.displayname || "",
        dob: existingData.dob || "",
        email: user.email || existingData.email || "",
        engagement: {
          followers: existingData.engagement?.followers || 0,
          following: existingData.engagement?.following || 0,
        },
        firstname: existingData.firstname || "",
        gender: existingData.gender || "",
        isAvailable: existingData.isAvailable ?? true,
        is_online: existingData.is_online ?? true,
        is_verified: existingData.is_verified ?? false,
        last_activity: formatDate(),
        lastname: existingData.lastname || "",
        location_tracking: {
          latitude: existingData.location_tracking?.latitude || 0,
          longitude: existingData.location_tracking?.longitude || 0,
        },
        login_method: "google",
        metadata: {
          created_at: existingData.metadata?.created_at || Date.now(),
          updated_at: Date.now(),
        },
        mobilenumber: existingData.mobilenumber || "",
        order: existingData.order || 0,
        preferences: {
          receive_emails: existingData.preferences?.receive_emails ?? true,
          receive_notifications: existingData.preferences?.receive_notifications ?? true,
        },
        profile_picture_url: user.photoURL || existingData.profile_picture_url || "",
        reported_issues: existingData.reported_issues || [],
        security: {
          pin_code: existingData.security?.pin_code || "",
          two_factor_enabled: existingData.security?.two_factor_enabled ?? false,
        },
        social_links: {
          facebook: existingData.social_links?.facebook || "",
          instagram: existingData.social_links?.instagram || "",
          twitter: existingData.social_links?.twitter || "",
        },
        status: "active",
        subscriptions: existingData.subscriptions || [],
        uid: user.uid,
        username: existingData.username || "",
        wallet: {
          balance: existingData.wallet?.balance || 0,
          transactions: existingData.wallet?.transactions || [],
          walletid: existingData.wallet?.walletid || 0,
        },
      };

      // Save user details to Firestore with merge enabled
      await setDoc(userRef, userDetails, { merge: true });

      console.log("User details updated in Firestore");
      openNotification("success", "Login Successful", `Welcome back, ${user.displayName}!`);
    } else {
      console.warn("⚠️ No user object found");
      openNotification("warning", "Login Issue", "No user object received.");
    }

    setTimeout(() => {
      navigate("/OverviewPage");
    }, 2000);
  } catch (error) {
    console.error("Login failed:", error);
    openNotification("error", "Login Failed", error.message);
  }
};

  
  

  // Mobile OTP AUTH Start --------------

  const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [confirmationResult, setConfirmationResult] = useState<any>(null);

  useEffect(() => {
    setUpRecaptcha();
  }, []);

  const setUpRecaptcha = () => {
    // Create reCAPTCHA verifier only if it's not already initialized
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();  // Clear previous instance if any
    }

    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      {
        size: "normal", // Use normal size for visible reCAPTCHA
        callback: (response: any) => {
          console.log("reCAPTCHA Verified", response);
        },
        "expired-callback": () => {
          console.log("reCAPTCHA expired, please try again.");
        },
      }
    );
  };

  const handlePhoneNumberSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Make sure phoneNumber is in the correct format
    const formattedPhoneNumber = `+${phoneNumber}`;
    console.log("Phone number:", formattedPhoneNumber);

    try {
      const appVerifier = window.recaptchaVerifier;
      const confirmation = await signInWithPhoneNumber(
        auth,
        formattedPhoneNumber,
        appVerifier
      );
      setConfirmationResult(confirmation);
      alert("Verification code sent! Please check your phone.");
    } catch (error) {
      console.error("Error during phone number authentication", error);
      alert("Error during phone number authentication. Please try again.");
    }
  };

  const handleVerificationSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!confirmationResult) {
      alert("No verification request found. Please enter your phone number first.");
      return;
    }

    try {
      const result = await confirmationResult.confirm(verificationCode);
      console.log("User authenticated successfully:", result.user);
      alert("Authentication successful!");
      
      navigate("/dashboard"); // Redirect to dashboard or required page
    } catch (error) {
      console.error("Error verifying OTP", error);
      alert("Incorrect OTP. Please try again.");
    }
  };

  // Mobile OTP AUTH End ----------------

  return (
    <>
     {contextHolder}
      <PagesAuthHeader />
      <div className="main-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5 mx-auto">
              <div className="d-flex flex-column justify-content-center">
                <div className="card p-sm-4 my-5"
                style={{
                  background: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "15px",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  borderColor: "#ffffff00",
                  color: "#fff",
                }}>
                  <div className="card-body">
                    <div className="text-center mb-3">
                      <h3 className="mb-2" style={{color: "white"}}>Welcome</h3>
                      <p style={{color: "white"}}>Enter your credentials to access your account</p>
                    </div>

                    {/* Phone OTP Start --------------- */}
                    <div>
                      <form onSubmit={handlePhoneNumberSubmit}>
                        <div className="log-form">
                          <div className="row">
                            <div className="col-md-12">
                              <label className="col-form-label" style={{color: "white"}}>Phone Number</label>
                              <div className="form-group">
                                <PhoneInput
                                  country={'lk'}
                                  value={phoneNumber}
                                  onChange={setPhoneNumber}
                                />
                              </div>
                            </div>
                          </div><br />

                          <div className="row mb-3">
                            {/* Terms and Conditions Section */}
                            <div className="col-md-12 d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  name="loginotp"
                                  id="loginotp"
                                  className="loginotp"
                                />
                                <label htmlFor="loginotp" className="form-check-label ms-2  justify-content-between" >
                                  By creating and/or using your account, you agree to our
                                  <a href="/terms" className="text-decoration-none" style={{color: "white"}}>&nbsp; Terms of Use</a> and
                                  <a href="/privacy-policy" className="text-decoration-none ms-3" style={{color: "white"}}>Privacy Policy</a>.
                                </label>

                                
                            </div>
                            <div id="recaptcha-container"></div>
                          </div>
                        </div>
                        <button type="submit" className="btn btn-primary w-100 login-btn" style={{color: "white"}}>
                          Send OTP
                        </button>
                      </form> <br />

                      {/* OTP Verification */}
                      {confirmationResult && (
                        <form onSubmit={handleVerificationSubmit}>
                          <div>
                            <label>Enter OTP:</label>
                            <input
                              type="number"
                              integerOnly length={6}
                              value={verificationCode}
                              onChange={(e) => setVerificationCode(e.target.value)}
                              className="form-control"
                              required
                            /><br />
                        
                          </div>
                          <button type="submit" className="btn btn-success w-100 login-btn">Verify OTP</button>
                        </form>
                      )}
                    </div> 
                    <br />
                    {/* Phone OTP End ------------------ */}

                    <div className="login-or mb-3">
                      <span className="span-or z-1" >Or sign in with </span>
                    </div>

                    <div className="row mb-3">
                      <div className="col-4">
                        <Link
                          to="#"
                          onClick={handleGoogleLogin}
                          className="btn btn-light d-flex align-items-center justify-content-center"
                           style={{color: "white"}}
                        >
                          <ImageWithBasePath
                            src="assets/img/icons/google-icon.svg"
                            className="me-2"
                            alt="Img"
                          />
                          Google
                        </Link>
                      </div>
                      <div className="col-4">
                        <Link
                          to="#"
                          onClick={handleFacebookLogin}
                          className="btn btn-light d-flex align-items-center justify-content-center"
                           style={{color: "white"}}
                        >
                          <ImageWithBasePath
                            src="assets/img/icons/fb-icon.svg"
                            className="me-2"
                            alt="Img"
                          />
                          Facebook
                        </Link>
                      </div>
                      <div className="col-4">
                        <Link
                          to="#"
                          // onClick={handleAppleLogin}
                          className="btn btn-light d-flex align-items-center justify-content-center"
                           style={{color: "white"}}
                        >
                          <DiApple size={20} className="text-gray-700" />
                          Apple
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    {/* <ImageWithBasePath
                      src="assets/img/bg/authentication-bg.png"
                      className="bg-left-top"
                      alt="Img"
                    />
                    <ImageWithBasePath
                      src="assets/img/bg/authentication-bg.png"
                      className="bg-right-bottom"
                      alt="Img"
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AuthFooter />
    </>
  );
};

export default Login2;
